(() => {
  const colors = {black:'שחור',white:'לבן',brown:'חום',cream:'קרם',beige:'בז׳',green:'ירוק',blue:'כחול',purple:'סגול',mint:'מנטה',yellow:'צהוב',pink:'ורוד',red:'אדום',grey:'אפור',gray:'אפור',orange:'כתום',turquoise:'טורקיז',navy:'נייבי',natural:'טבעי',stone:'אבן',espresso:'אספרסו',vanilla:'וניל',midnight:'מידנייט',other:'אחר'};
  const sizeOrder = ['XXS','XS','XS/S','S','S/M','M','M/L','L','L/XL','XL','XL/XXL','XXL','2XL','3XL','4XL','5XL'];
  function init() {
    document.querySelectorAll('[data-ge-filter-scope]').forEach(scope => {
      if (scope.dataset.geFilterReady) return;
      const controls = scope.querySelector('[data-ge-filters]');
      if (!controls) return;
      const cards = [...scope.querySelectorAll('[data-ge-color-card]')].map(el => {
        try {return {el,stock:JSON.parse(el.querySelector('[data-ge-stock]').textContent)};} catch {return {el,stock:[]};}
      });
      const size = controls.querySelector('[data-ge-size]');
      const color = controls.querySelector('[data-ge-color-filter]');
      const clear = controls.querySelector('[data-ge-clear]');
      const count = controls.querySelector('[data-ge-count]');
      const empty = scope.querySelector('[data-ge-empty]');
      const sizes = [...new Set(cards.flatMap(card => card.stock.flatMap(product => product.sizes)))];
      sizes.sort((a,b) => {const ai=sizeOrder.indexOf(a),bi=sizeOrder.indexOf(b);return ai<0 || bi<0 ? a.localeCompare(b,undefined,{numeric:true}) : ai-bi;});
      sizes.forEach(value => size.add(new Option(value,value)));
      [...new Set(cards.flatMap(card => card.stock.map(product => product.color)))].sort((a,b)=>(colors[a]||a).localeCompare(colors[b]||b,'he')).forEach(value => color.add(new Option(colors[value]||value,value)));
      const apply = () => {
        const filtering = Boolean(size.value || color.value);
        const limit = filtering ? Infinity : Number(scope.dataset.geInitialLimit || Infinity);
        let found=0,visible=0;
        cards.forEach(card => {
          const matches = product => (!size.value || product.sizes.includes(size.value)) && (!color.value || product.color===color.value);
          const products = card.stock.filter(matches);
          const match = !filtering || products.length>0;
          card.el.hidden = !match || found>=limit;
          if (match) found++;
          if (!card.el.hidden) visible++;
          const links=[...card.el.querySelectorAll('[data-ge-color]')];
          links.forEach(link => {const product=card.stock.find(item=>item.id===link.dataset.geColor);link.setAttribute('aria-disabled',String(filtering && (!product || !matches(product))));});
          if (filtering && products.length) {
            const active=links.find(link=>link.classList.contains('is-active') && products.some(product=>product.id===link.dataset.geColor));
            const next=active || links.find(link=>link.dataset.geColor===products[0].id);
            if (next && !next.classList.contains('is-active')) next.click();
          }
        });
        empty.hidden=visible>0;
        count.textContent=filtering ? visible+' '+count.dataset.countLabel : '';
        clear.hidden=!filtering;
      };
      scope.addEventListener('click',event=>{const link=event.target.closest('[data-ge-color]');if(link && link.getAttribute('aria-disabled')==='true'){event.preventDefault();event.stopPropagation();}},true);
      size.addEventListener('change',apply);color.addEventListener('change',apply);
      clear.addEventListener('click',()=>{size.value='';color.value='';apply();});
      scope.dataset.geFilterReady='true';controls.hidden=false;apply();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('guttos:filters:init',init);
  document.addEventListener('shopify:section:load',init);
})();
